import {
  ApolloClient,
  createHttpLink,
  from,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { apiConfig } from "./config";
import { getOrg } from "./src/utils/site";
import { inBrowser } from "./src/utils/utils";

const httpLink = createHttpLink({
  uri: apiConfig.GRAPHQL_ENDPOINT,
});

const authLink = setContext(async (_, { headers }) => {
  let token = "";
  let openidToken = "";

  if (inBrowser) {
    token = sessionStorage.getItem("token") ?? "";
    openidToken = sessionStorage.getItem("openidToken") ?? "";
  }

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      "x-openid-auth": openidToken ? `Bearer ${openidToken}` : "",
      "x-org": getOrg(),
    },
  };
});
const client = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      KennelPolicy: {
        fields: {
          metadata: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming);
            },
          },
        },
      },
      KennelClient: {
        fields: {
          metadata: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming);
            },
          },
        },
      },
      KennelFee: {
        keyFields: ["name", "total"],
      },
      DraftPreview: {
        fields: {
          policyPreviews: {
            merge(_existing, incoming) {
              return incoming;
            },
          },
        },
      },
    },
  }),
  link: from([authLink, httpLink]),
});

export default client;
